<script>
import { mapActions, mapState } from 'vuex';

import PaymentMethod from './payment_method.vue';

export default {
  components: {
    PaymentMethod
  },

  computed: {
    ...mapState([
      'selectedPspCode',
      'psps'
    ])
  },

  methods: {
    ...mapActions([
      'setSelectedPspCode'
    ]),

    checked(code) {
      return this.selectedPspCode === code;
    },

    updatePaymentMethod(code) {
      this.setSelectedPspCode({
        code
      });
    },
  }
};
</script>

<template>
  <div>
    <h3 class="mb-4">
      {{ t('pay.js.marketing.payment_methods.title') }}
    </h3>

    <div class="c-payment-methods mb-4">
      <div class="row g-2 g-lg-4">
        <payment-method
          v-for="psp in psps"
          :key="psp.code"
          :disabled="psp.disabled"
          :code="psp.code"
          :name="psp.name"
          :checked="checked(psp.code)"
          @update:payment-method="updatePaymentMethod"
        />
      </div>
    </div>
  </div>
</template>
